import { closeActivePopup, setActiveEventId } from "@client/actions";
import { type BaseAppState } from "@client/types";

export const chooseEvent = (id: string | null) => (dispatch: any, getState: () => BaseAppState) => {
  if (!getState().isEditMode) {
    dispatch(closeActivePopup());
  }
  dispatch(setActiveEventId(id));
};
